"use client";

import Script from "next/script";

const url: string | undefined =
	process.env.NEXT_PUBLIC_ONE_TRUST_COMPLIANCE_LIBRARY_SCRIPT_URL;

// OneTrust compliance library handling opt-in/opt-out choices
export default function CookieCompliance() {
	if (url) {
		return (
			<Script
				id="oneTrustComplianceLibraryScript"
				strategy="lazyOnload"
				src={url}
			/>
		);
	}
}
